var _stop, _stop2, _stop3, _stop4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 21,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id, ")"),
    d: "M15.578 0H4.568C2.696 0 1.07 1.073.359 2.807c-.714 1.733-.349 3.632.994 4.952l.83.826a8.411 8.411 0 0 0-.05 3.582l1.028-.198a7.45 7.45 0 0 0 3.183 4.739 7.453 7.453 0 0 0 4.145 1.254c.348 0 .68-.033 1.028-.066l1.79 1.783c.88.875 1.99 1.321 3.151 1.321.58 0 1.177-.116 1.758-.347C19.922 19.943 21 18.36 21 16.51V5.4C21 2.41 18.563 0 15.578 0ZM4.304 11.722l1.028-.198c-.564-2.84 1.276-5.597 4.128-6.175l-.199-1.024a6.399 6.399 0 0 1 1.26-.132c1.227 0 2.438.364 3.499 1.057a6.229 6.229 0 0 1 2.686 3.995c.331 1.651 0 3.319-.945 4.722-.929 1.403-2.371 2.344-4.013 2.675a6.293 6.293 0 0 1-7.444-4.92Zm15.519 4.77c0 1.635-1.061 2.659-2.056 3.072-.995.412-2.47.429-3.631-.727l-1.277-1.271a7.44 7.44 0 0 0 3.88-2.939c1.11-1.65 1.509-3.648 1.11-5.596a7.451 7.451 0 0 0-3.183-4.739 7.429 7.429 0 0 0-5.62-1.106l-.2-1.023a8.549 8.549 0 0 0-5.438 3.615A9.31 9.31 0 0 0 2.58 7.33l-.398-.396c-1.177-1.172-1.16-2.675-.73-3.682.415-1.007 1.46-2.08 3.134-2.08h11.01c2.338 0 4.244 1.899 4.244 4.227v11.094h-.016Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#".concat(_id2, ")"),
    d: "M14.12 10.5a3.622 3.622 0 0 0-3.632-3.616A3.622 3.622 0 0 0 6.857 10.5a3.622 3.622 0 0 0 3.631 3.615c2.006 0 3.631-1.634 3.631-3.615Zm-3.632 2.427a2.443 2.443 0 1 1 0-4.887 2.443 2.443 0 1 1 0 4.887Z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _id,
    x1: -0.009,
    x2: 20.996,
    y1: 10.494,
    y2: 10.494,
    gradientUnits: "userSpaceOnUse"
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#17D3FF"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#00EA90"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: _id2,
    x1: 6.871,
    x2: 14.12,
    y1: 10.492,
    y2: 10.492,
    gradientUnits: "userSpaceOnUse"
  }, _stop3 || (_stop3 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.337,
    stopColor: "#17D3FF"
  })), _stop4 || (_stop4 = /*#__PURE__*/React.createElement("stop", {
    offset: 0.862,
    stopColor: "#00EA90"
  })))));
};
export default SvgLogo;